import { Box, Typography } from "@mui/material";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { FormattedMessage } from "react-intl";

export default function PercentChangeFooter({ percent }) {
    if (percent > 0) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <TrendingUpIcon sx={{ fontSize: 16, color: 'success.main' }} />
                <Typography variant="caption" sx={{ color: 'success.main', fontWeight: 600 }}>
                    +{percent}% <FormattedMessage id="more_month" />
                </Typography>
            </Box>
        );
    }
    if (percent < 0) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <TrendingDownIcon sx={{ fontSize: 16, color: 'error.main' }} />
                <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 600 }}>
                    {percent}% <FormattedMessage id="less_month" />
                </Typography>
            </Box>
        );
    }
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <TrendingFlatIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography variant="caption" color="text.secondary">
                <FormattedMessage id="stable_growth" />
            </Typography>
        </Box>
    );
}
